import React, { useEffect } from "react";
import RestaurantCard from "./RestaurantCard";
import PromotionSection from "./PromotionSection";
import { getAllStores, getFilterStores } from "../actions/storeActions";
import { useDispatch, useSelector } from "react-redux";
import { ChevronRight } from "lucide-react";
import { useLocation } from "react-router-dom";
import logo from "../assetsWeb/images/logoNew.png";

const RestaurantList = () => {
  const store = useSelector((state) => state.store);
  const { loading } = store;
  const locationUrl = useLocation();
  const queryParams = new URLSearchParams(locationUrl.search);
  const filter = queryParams.get("filter");
  const dispatch = useDispatch();
  const storeData = async (e) => {
    const obj = {
      category: locationUrl?.pathname.replace(/^\/+/, ""),
      subCategory: filter,
    };
    for (let key of Object.keys(obj)) {
      if (obj[key] === "" || !obj[key]) {
        delete obj[key];
      }
    }
    dispatch(getFilterStores(obj));
  };
  useEffect(() => {
    storeData();
  }, [locationUrl, filter]);
  console.log(store, "store");

  const promotedRestaurants = [
    {
      id: 1,
      name: "Padthaiwok",
      image:
        "https://images.pexels.com/photos/1640772/pexels-photo-1640772.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      rating: 95,
      reviews: 500,
      category: "Asian",
    },
    {
      id: 2,
      name: "Miss Sushi",
      image:
        "https://images.pexels.com/photos/2098085/pexels-photo-2098085.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      rating: 94,
      reviews: 500,
      category: "Japanese",
    },
    {
      id: 3,
      name: "Goxo",
      image:
        "https://images.pexels.com/photos/15899469/pexels-photo-15899469/free-photo-of-chef-preparing-dish-in-the-kitchen.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      rating: 95,
      reviews: 500,
      category: "Premium Restaurant",
    },
  ];

  return (
    <>
      {loading ? (
        <div className="loading-overlay">
          <img src={logo} alt="Loading" className="loading-logo" />
          <div className="loading-text">Loading...</div>
        </div>
      ) : (
        <div className="restaurant-list">
          <div className="breadcrumb-navigation">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Madrid</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Food
                </li>
              </ol>
            </nav>
          </div>

          <div className="page-title">
            <h1>Food delivery in Madrid</h1>
          </div>

          {store?.store?.some((x) => x.isPromoted === true) && (
            <div className="promotion-section">
              <div className="section-header">
                <div className="promotion-icon">🔥</div>
                <h2 className="section-title">Promotions</h2>
                {/* <a href="/promotions" className="see-all-link"> */}
                See all <ChevronRight size={16} />
                {/* </a> */}
              </div>

              <div className="row">
                {store?.store
                  ?.filter((restaurant) => restaurant.isPromoted)
                  .map((restaurant) => (
                    <div
                      className="col-12 col-md-6 col-lg-4 mb-4"
                      key={restaurant?.id}
                    >
                      <RestaurantCard restaurant={restaurant} />
                    </div>
                  ))}
              </div>
            </div>
          )}

          {/* <PromotionSection restaurants={promotedRestaurants} /> */}

          <div className="all-stores-section">
            <h2 className="section-title">All Stores</h2>
            <div className="row">
              {store?.store?.map((restaurant) => (
                <div
                  className="col-12 col-md-6 col-lg-4 mb-4\"
                  key={restaurant?.id}
                >
                  <RestaurantCard restaurant={restaurant} />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RestaurantList;
